import React, { useRef, useState } from "react";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { PhoneInput } from "react-international-phone";
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { dsfAdminAdd, dsfAdminUpdate } from "../../service/dsfAdminService";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { duplicate } from "../../service/api-service";
import EmailValidationApi from "../../components/EmailValidationApi";
import MobileValidationApi from "../../components/MobileValidationApi";
import DropdownApi from "../../components/DropdownApi";

export default function DsfAdminAdd(modalProps: any) {

  const [name, setName] = useState(modalProps?.admin?.name || "");
  const [surname, setSurname] = useState(modalProps?.admin?.surname || "");
  const [mobile, setMobile] = useState(modalProps?.admin?.mobile || "");
  const [email, setEmail] = useState(modalProps?.admin?.email || "");
  const [emailColor, setEmailColor] = useState('primary');
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [emailMessage, setEmailMessage] = useState("");
  const [userId, setUserId] = useState(modalProps?.admin?.user_id || '');
  const [mobileLoading, setMobileLoading] = React.useState(false);
  const [emailLoading, setEmailLoading] = React.useState(false);

  async function addAdmin() {
    modalProps.setGlobalLoading(true);
    if (modalProps.id) {
      dsfAdminUpdate(modalProps.id, {
        name, surname, mobile, email,
        user_id: userId
      }).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({ severity: 'success', summary: 'DSF Admin Updated Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setReload(!modalProps.reload);
      })
    } else {
      dsfAdminAdd(name, surname, mobile, email).then((r: any) => {
        modalProps.setGlobalLoading(false);
        modalProps.toast.current.show({ severity: 'success', summary: 'DSF Admin Created Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setReload(!modalProps.reload);
      })
    }
  }

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Name</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
            </FormControl>
          </Stack>
          <Stack spacing={1}>
            <FormLabel>Surname</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Surname"
                value={surname} onChange={e => setSurname(e.target.value)} />
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2}>
            <MobileValidationApi
              label="Mobile"
              mobile={mobile}
              setMobile={setMobile}
              type="Admin"
              loading={mobileLoading}
              setLoading={setMobileLoading}
            />
            <EmailValidationApi
              label="Email"
              email={email}
              setEmail={setEmail}
              type="Admin"
              loading={emailLoading}
              setLoading={setEmailLoading}
            />
          </Stack>
        </Stack>
      </Stack>
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => addAdmin()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}